import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-1fd0ce7b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-screen bg-[var(--bg-color)] l:rounded-l-[100px] l:h-[600px] l:w-[800px] relative"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex flex-col gap-y-5 px-[72px] py-16" }
const _hoisted_5 = { class: "flex flex-col gap-y-10 px-10 l:grid l:grid-cols-2" }
const _hoisted_6 = { class: "flex flex-col px-[45px]" }
const _hoisted_7 = { for: "name" }
const _hoisted_8 = { class: "flex flex-col px-[45px]" }
const _hoisted_9 = { for: "phone" }
const _hoisted_10 = { class: "flex flex-col px-[45px]" }
const _hoisted_11 = { for: "email" }
const _hoisted_12 = { class: "flex flex-col px-[45px]" }
const _hoisted_13 = { for: "text" }
const _hoisted_14 = { class: "grid grid-cols-[24px_auto] gap-x-6 mb-16" }
const _hoisted_15 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_16 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_17 = {
  key: 1,
  class: "h-screen bg-[var(--bg-color)] l:h-[600px] l:w-[800px] rounded-l-[100px]"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "flex flex-col items-center justify-center gap-y-5 h-full" }

import { useWindowSize } from '@vueuse/core';
import { vMaska } from 'maska';
import { ref, computed } from 'vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import type { MainPageForm } from '@/types/MainPageForm';
import { useGlobalStore } from '@/stores/global';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'Form',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const { t } = useI18n();
const { width } = useWindowSize();

const { isMobile } = useGlobalStore();

const options = { mask: '+7 (###) ###-##-##' };

const form = ref<MainPageForm>({} as MainPageForm);
const agreement = ref<boolean>(false);
const sended = ref<boolean>(false);

const sendForm = () => {
    // ToDo: подключить PhPMailer.
    console.log('form:', form.value);
    sended.value = true;
};

const isDisabled = computed(() => {
    return form.value.name && /^\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}$/.test(form.value.phone) && agreement.value;
});

const onLoad = () => {
    if (!isMobile) return;

    const body = document.querySelector('body');
    if (body) {
        body.style.overflow = 'hidden';
    }
};

const onClose = () => {
    if (isMobile) {
        const body = document.querySelector('body');
        if (body) {
            body.style.overflow = 'auto';
        }
    }

    emit('close');
};

onLoad();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (!sended.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "absolute top-16 right-10 cursor-pointer",
          onClick: onClose
        }, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(BaseTypography, {
            text: _unref(t)('contacts.form.title'),
            type: _unref(width) > 768 ? 'subtitle' : 'title-m',
            color: "var(--black-color)"
          }, null, 8, ["text", "type"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('contacts.form.subtitle'),
            type: _unref(width) > 768 ? 'special-body3' : 'body3-m',
            color: "var(--black-color)"
          }, null, 8, ["text", "type"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, [
              _createVNode(BaseTypography, {
                text: _unref(t)('contacts.form.name'),
                type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                color: "var(--black-color)"
              }, null, 8, ["text", "type"])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
              id: "name",
              name: "name",
              placeholder: "Иван",
              class: "edit bk",
              type: "text",
              required: ""
            }, null, 512), [
              [_vModelText, form.value.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", _hoisted_9, [
              _createVNode(BaseTypography, {
                text: _unref(t)('contacts.form.phone'),
                type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                color: "var(--black-color)"
              }, null, 8, ["text", "type"])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.phone) = $event)),
              placeholder: "+7(000)000-00-00",
              id: "phone",
              name: "phone",
              class: "edit bk",
              type: "text",
              required: ""
            }, null, 512), [
              [_vModelText, form.value.phone],
              [_unref(vMaska), void 0, options]
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, [
              _createVNode(BaseTypography, {
                text: _unref(t)('contacts.form.email'),
                type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                color: "var(--black-color)"
              }, null, 8, ["text", "type"])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.email) = $event)),
              placeholder: "ivan.ivanov@mail.ru",
              id: "email",
              name: "email",
              class: "edit bk",
              type: "email"
            }, null, 512), [
              [_vModelText, form.value.email]
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("label", _hoisted_13, [
              _createVNode(BaseTypography, {
                text: _unref(t)('contacts.form.message'),
                type: _unref(width) > 768 ? 'special-body2' : 'body2-m',
                color: "var(--black-color)"
              }, null, 8, ["text", "type"])
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.text) = $event)),
              id: "text",
              name: "text",
              placeholder: "Ваше сообщение...",
              class: "edit bk",
              type: "text"
            }, null, 512), [
              [_vModelText, form.value.text]
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["h-6 w-6 border-[4px] border-[var(--primary-color)] rounded-full cursor-pointer", { 'border-[var(--secondary-color)]': agreement.value }]),
              onClick: _cache[4] || (_cache[4] = () => (agreement.value = !agreement.value))
            }, null, 2),
            _createElementVNode("div", null, [
              _createVNode(BaseTypography, {
                text: _unref(t)('contacts.form.policy.first'),
                type: _unref(width) < 900 ? 'caption-m' : 'caption',
                tag: "span"
              }, null, 8, ["text", "type"]),
              _createVNode(_component_router_link, { to: "/consent" }, {
                default: _withCtx(() => [
                  _createVNode(BaseTypography, {
                    text: _unref(t)('contacts.form.policy.second'),
                    type: _unref(width) < 900 ? 'caption-m' : 'caption',
                    class: "underline",
                    tag: "span"
                  }, null, 8, ["text", "type"])
                ]),
                _: 1
              }),
              _createVNode(BaseTypography, {
                text: _unref(t)('contacts.form.policy.third'),
                type: _unref(width) < 900 ? 'caption-m' : 'caption',
                tag: "span"
              }, null, 8, ["text", "type"]),
              _createVNode(_component_router_link, { to: "/policy" }, {
                default: _withCtx(() => [
                  _createVNode(BaseTypography, {
                    text: _unref(t)('contacts.form.policy.fourth'),
                    type: _unref(width) < 900 ? 'caption-m' : 'caption',
                    class: "underline",
                    tag: "span"
                  }, null, 8, ["text", "type"])
                ]),
                _: 1
              })
            ])
          ]),
          (_unref(width) > 900)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(BaseButton, {
                  text: _unref(t)('contacts.form.send'),
                  type: _unref(width) > 768 ? 'subtitle4' : 'subtitle4-m',
                  color: "var(--base-white)",
                  ui: !isDisabled.value ? 'disabled' : 'primary-with-back',
                  disabled: !isDisabled.value,
                  onClick: sendForm
                }, null, 8, ["text", "type", "ui", "disabled"])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(width) < 900)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(BaseButton, {
                text: _unref(t)('contacts.form.send'),
                type: _unref(width) > 768 ? 'subtitle4' : 'subtitle4-m',
                color: "var(--base-white)",
                ui: !isDisabled.value ? 'disabled' : 'primary-with-back',
                disabled: !isDisabled.value,
                class: "mb-12",
                onClick: sendForm
              }, null, 8, ["text", "type", "ui", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
        _createElementVNode("div", {
          class: "absolute top-16 right-10 cursor-pointer",
          onClick: onClose
        }, _hoisted_19),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(BaseTypography, {
            text: _unref(t)('contacts.form.thanks.first'),
            type: _unref(width) < 900 ? 'subtitle2-m' : 'subtitle2'
          }, null, 8, ["text", "type"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('contacts.form.thanks.second'),
            type: _unref(width) < 900 ? 'subtitle2-m' : 'subtitle2'
          }, null, 8, ["text", "type"])
        ])
      ]))
}
}

})